/**
 * 全局格式化工具
 */

/**
 * 将服务端返回的 ISO 时间字符串格式化为 "YYYY-MM-DD HH:mm:ss"
 * 支持格式如：2026-03-02T13:40:58.5、2026-03-02T13:40:58.500Z 等
 * @param {string|number|Date} dateTime - 日期时间字符串、时间戳或 Date 对象
 * @returns {string} 格式化后的字符串，无效时返回 '-'
 */
export function formatDateTime(dateTime) {
  if (dateTime === undefined || dateTime === null || dateTime === '') {
    return '-'
  }
  const date = new Date(dateTime)
  if (isNaN(date.getTime())) {
    return '-'
  }
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
